// extracted by mini-css-extract-plugin
export var fontBold = "Kv69zXr264F4GK7s00Us";
export var fontMedium = "I8SFxEBv86cr8Mo0ZX3D";
export var fontRegular = "P8vAAIrM7CQOv0QmOnPt";
export var fontSemiBold = "G_xtrJlNpmlaWuDXk1Fk";